module.exports = "./img/a3b3ae9b4a3fbb211acfcea324a1ddc8.jpg";